<template>
  <v-content class="pa-0 bg_color" id="top">
    <v-layout justify-center fluid fill-height>
      <v-flex>
        <!--ドロワー背景overlay1-->
        <div class="overlay1"></div>
        <section class="mv">
          <div class="mv_contents">
            <div class="mv_contents_box">
              <div class="mv_contents_box_title">
                <img src="../assets/img/2045.svg" alt="2045">
                <h1>無人化、非対面の先へ</h1>
              </div>
              <div class="mv_contents_box_btn">
                <a href="/download" class="download_btn">資料ダウンロード</a>
                <a href="https://prtimes.jp/main/html/rd/p/000000067.000030247.html" class="rental_btn" target="_blank">レンタルでご利用</a>
              </div>
            </div>
          </div>
        </section>
        <section class="contents">
          <section class="about">
            <section class="about_contents fadeUpTrigger">
              <img src="../assets/img/smart_mirror_logo_w.svg" alt="smart mirror">
              <p>Smartmirror2045<br class="sp_only">（スマートミラー2045）は、<br class="sp_only"><span class="font_700">ジーエルシーが企画開発</span>した、<br>
              <span class="font_700">Android OS搭載</span>で、<br class="sp_only">等身大の姿を映し出せるラージサイズの<span class="font_700"><br class="sp_only">タッチパネルミラーディスプレイ</span>です。</p>
            </section>
          </section>
          <section class="product" id="product">
            <h2 class="fadeUpTrigger">product</h2>
            <section class="product_contents fadeUpTrigger">
              <div class="product_contents_box">
                <img src="../assets/img/product_2.jpg" alt="for Fitness Wall MOUNTED">
                <h3><span class="product_contents_h3_black">for Fitness</span><br>Wall MOUNTED</h3>
                <p><span class="font_700">ディスプレイ</span><br>32inch<br><span class="font_700">本体寸法</span><br>(W)455(H)1200(D)30mm</p>
              </div>
              <div class="product_contents_box">
                <img src="../assets/img/product_1.jpg" alt="for Fitness Floor standing">
                <h3><span class="product_contents_h3_black">for Fitness</span><br>Floor standing</h3>
                <p><span class="font_700">ディスプレイ</span><br>43inch<br><span class="font_700">本体寸法</span><br>(W)600(H)1800(D)30mm</p>
              </div>
              <div class="product_contents_box">
                <img src="../assets/img/product_3.jpg" alt="or Retail Wall MOUNTED">
                <h3><span class="product_contents_h3_gray">for Retail</span><br>Wall MOUNTED</h3>
                <p><span class="font_700">ディスプレイ</span><br>32inch・43inch・55inch<br><span class="font_700">本体寸法</span><br>(W)57.6(H)800.6(D)63mm<br>(W)612.5(H)1044(D)63.5mm <br>(W)765.5(H)1341.5(D)65.5mm</p>
              </div>
              <div class="product_contents_box">
                <img src="../assets/img/product_4.jpg" alt="for Retail Kiosk">
                <h3><span class="product_contents_h3_gray">for Retail</span><br>Kiosk</h3>
                <p><span class="font_700">ディスプレイ</span><br>32inch・43inch<br><span class="font_700">本体寸法</span><br>(W)550(H)1780(D)200mm<br>(W)850(H)1934.6(D)500mm</p>
              </div>
            </section>
            <div class="product_contents_back"></div>
          </section>
          <section class="spec fadeUpTrigger">
            <div class="spec_box">
              <img src="../assets/img/android_os.svg" alt="Android OS"><h3>Android<br class="sp_only"> OS</h3>
            </div>
            <div class="spec_box">
              <img src="../assets/img/audio_speaker.svg" alt="audio speaker"><h3>Audio<br class="sp_only"> Speaker</h3>
            </div>
            <div class="spec_box">
              <img src="../assets/img/camera.svg" alt="Camera"><h3>Camera</h3>
            </div>
            <div class="spec_box">
              <img src="../assets/img/usb.svg" alt="USB"><h3>USB</h3>
            </div>
            <div class="spec_box">
              <img src="../assets/img/wi-fi.svg" alt="Wi-Fi"><h3>Wi-Fi</h3>
            </div>
            <div class="spec_box">
              <img src="../assets/img/lan.svg" alt="LAN"><h3>LAN</h3>
            </div>
          </section>
          <section class="use_case fadeUpTrigger" id="case">
            <h2>Use Case</h2>
            <section class="use_case_contents">
              <!-- Swiper START -->
              <div class="swiper-container">
                <!-- メイン表示部分 -->
                <div class="swiper-wrapper">
                  <!-- 各スライド -->
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_9.svg" alt="リテールメディア" style="width: 380px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>リテールメディア</h4>
                        <p>新たなマネタイズポイントになりうる広告プラットフォーム事業として、実店舗における広告メディアの顧客接点デバイスとして活用可能です。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_1.svg" alt="商品提案、オムニチャネル" style="width: 230px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>商品提案、オムニチャネル</h4>
                        <p>商品提案、QR読取りによる自社ECサイトへの誘導など、アパレル、百貨店等の店舗DXソリューションとして、専用アプリケーションと組み合わせることで実現可能です。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_2.svg" alt="診断、レコメンド" style="width: 218px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>診断、レコメンド</h4>
                        <p>画像認識や問診などの各種診断結果にもとづく商品のレコメンドを実施。専門知識が必要な接客に代替するソリューションとして活用可能です。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_3.svg" alt="リモート接客" style="width: 280px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>リモート接客</h4>
                        <p>非対面接客システムと組み合わせることにより、商業施設、店舗、オフィス、などに受付担当者を配さずとも、非対面、かつ、一元集約にて、顧客応対が可能となります。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_4.svg" alt="オンラインフィットネス" style="width: 210px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>オンラインフィットネス</h4>
                        <p>双方向コミュニケーション、オンデマンド動画配信、による本格的なオンラインフィットネスに取り組むことが可能になります。<br>ホテル、マンション等へも導入可能です。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_5.svg" alt="大画面デモ" style="width: 220px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>大画面デモ</h4>
                        <p>東京ビックサイト、幕張メッセなどで開始される展示会において、自社サービス、自社アプリケーションを、大画面で操作説明しながら紹介することが可能になります。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_6.svg" alt="オフィス受付" style="width: 140px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>オフィス受付</h4>
                        <p>オフィスエントランスの受付として設置。AndroidOS、ブラウザベースで動く受付システムを搭載して受付効率化にも繋がります。<br>スマートなオフィスの印象を与えることが可能です。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_7.svg" alt="観光案内" style="width: 240px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>観光案内</h4>
                        <p>AIチャットボットや多言語コールセンターソリューションと組み合わせることで、観光客への各種情報提供、問合せ対応を非対面で実施することが可能となります。</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="use_case_contents_box">
                      <div class="use_case_contents_box_img">
                        <img src="../assets/img/case_8.svg" alt="マンション掲示板" style="width: 240px;">
                      </div>
                      <div class="use_case_contents_box_text">
                        <h4>マンション掲示板</h4>
                        <p>マンション共用部のデジタルサイネージとして活用可能です。紙の貼り替え作業を不要とし、リアルタイムかつ遠隔操作で多彩な情報を発信することができます。</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-pagination"></div>
              </div>
              <!-- Swiper END -->
            </section>
          </section>
          <section class="qa-list fadeUpTrigger" id="faq">
            <h2>FAQ</h2>
            <dl class="qa">
              <dt>レンタルで利用することはできますか？</dt>
              <dd>
              <p>「"for Fitness"Wall mounted」は、<a href="https://prtimes.jp/main/html/rd/p/000000067.000030247.html" target="_blank" rel="noopener noreferrer">こちら</a>からレンタルをお申込みいただけます。それ以外の製品については、フォームよりお問合せください。</p>
              </dd>
            </dl>
            <dl class="qa">
              <dt>OSを変更することはできますか？</dt>
              <dd>
              <p>弊社製品は、Android OS 搭載の製品のみになります。</p>
              </dd>
            </dl>
            <dl class="qa">
              <dt>壁やスタンドへの取付規格は何になりますか？</dt>
              <dd>
              <p>VESA規格になります。</p>
              </dd>
            </dl>
            <dl class="qa">
              <dt>利用事例はどんなものがありますか？</dt>
              <dd>
              <p><a href="https://twitter.com/GLC_smartmirror" target="_blank" rel="noopener noreferrer">こちら</a>に、一部事例を掲載しております。</p>
              </dd>
            </dl>
            <dl class="qa">
              <dt>肌診断、バーチャルメイクなどは可能ですか？</dt>
              <dd>
              <p>弊社からはハードウェアをご提供しますので、弊社製品上で動作するアプリケーションを別途ご準備いただければ実現可能です。</p>
              </dd>
            </dl>
            <dl class="qa">
              <dt>技適は取得していますか？</dt>
              <dd>
              <p>取得済です。支援機関と連携して必要な対応を行っております。</p>
              </dd>
            </dl>
          </section>
          <section class="contact fadeUpTrigger" id="contact">
            <div class="contact_contents">
              <div class="contact_contents_box">
                <img src="../assets/img/contact.png" alt="contact">
                <div class="contact_contents_box_text">
                  <h2>contact</h2>
                  <p>お問い合わせ/お申込みはお気軽に<br class="sp_only">ご連絡ください。<br>
                  また、サービス資料を<br class="sp_only">ダウンロードいただけます。</p>
                  <div class="mv_contents_box_btn">
                    <a href="/contact" class="download_btn">お問合せ</a>
                    <a href="/download" class="rental_btn">資料ダウンロード</a>
                  </div>
                </div>
              </div>
              <div class="contact_contents_back"></div>
            </div>
          </section>
          <section class="partner fadeUpTrigger">
            <h2>partner</h2>
            <div class="partner_contents">
              <a href="https://www.revieve.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_1.jpg" alt="Revieve Inc."></a>
              <a href="https://www.nextremer.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_2.jpg" alt="Nextremer"></a>
              <a href="https://usideu.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_3.jpg" alt="UsideU"></a>
              <a href="https://www.sportip.jp/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_4.jpg" alt="Sportip"></a>
              <a href="https://www.unicast.ne.jp/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_5.jpg" alt="unicast"></a>
              <a href="https://hatapro.co.jp/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/partner_6.jpg" alt="hatapro"></a>
            </div>
          </section>
        </section>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '../assets/css/swiper.min.css'
export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  methods: {
    showMenu (drawer) {
      this.drawer = drawer
    }
  }
}
</script>

<style scoped>

.mv {
  background-image:url("../assets/img/top_kv.jpg");
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
}
.mv img {
  width: 325px;
}
.mv_contents {
  position: relative;
  max-width: 750px;
  margin: 0 auto;
  height: 100%;
}
.mv_contents_box {
  position: absolute;
  top: 37%;
  margin: auto;
  right: 0%;
}
.mv_contents_box_title {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mv_contents_box_title h1 {
  margin: 30px auto 50px;
}
.mv_contents_box_btn {
  display: flex;
  justify-content: space-between;
}
.download_btn {
  border: solid 1px #000000;
  padding: 16px 12px;
}
.download_btn:hover {
  color: #ffffff;
  background-color: #0071e3;
  border: solid 1px #0071e3;
}
.rental_btn {
  padding: 16px 12px;
  color: #ffffff;
  background-color: #000000;
}
.rental_btn:hover {
  opacity: 0.5;
}
.mv_contents_box a {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-feature-settings: "palt";
  line-height: 1;
  letter-spacing: 2px;
  text-align: center;
  width: 48%;
}

/*---- all----*/
.about_contents,.product_contents,.spec {
  max-width: 960px;
  margin: auto;
}
.font_700 {
  font-weight: 700;
}

/*---- about----*/
.about {
  background-color: #000000;
  padding: 70px 0px 120px;
  text-align: center;
}

.about_contents p {
  color: #FFFFFF;
  font-weight: 300;
}
.about_contents img {
  width: 450px;
  padding-bottom: 50px;
}

/*---- product----*/
.product {
  background-color: #000000;
  position: relative;
}
.product h2 {
  text-align: center;
  color: #ffffff;
  border-top: solid 1px #000000;
}
.product_contents {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 1;
  position: relative;
}
.product_contents_h3_black {
  font-size: 14px;
  color: #FFFFFF;
  background-color: #000000;
  padding: 3px 6px;
}
.product_contents_h3_gray {
  font-size: 14px;
  color: #FFFFFF;
  background-color: #808080;
  padding: 3px 6px;
}
.product_contents_box p {
  font-size: 12px;
  line-height: 1.6;
  padding-top: 6px;
}
.product_contents_box img {
  width: 230px;
  padding-bottom: 10px;
}
.product_contents_back {
  background-color: #FFFFFF;
  clip-path: polygon(0 34%, 100% 0, 100% 100%, 0% 100%);
  width: 100%;
  height: 300px;
  position: absolute;
  bottom: -1px;
  border-bottom: solid 1px #fff;
}

/*---- product----*/
.spec {
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
}
.spec_box {
  text-align: center;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
}
.spec_box img {
  height: 40px;
  padding-bottom: 20px;
}
.spec_box h3 {
  font-size: 16px;
  letter-spacing: 3px;
}

/*---- ここからスワイパー ----*/
.swiper-container {
  max-width: 960px;
  background-color: #F7F7F7;
}
.swiper-wrapper {
  width: 100%;
}
.swiper-slide {
  background-color: #F7F7F7;
  padding: 50px 160px;
  box-sizing: border-box;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  right: 0px!important;
  background-color: #ffffff;
  width: 17%!important;
  height: 100px!important;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  left: 0px!important;
  background-color: #ffffff;
  width: 17%!important;
  height: 100px!important;
}
/*---- ここまでスワイパー ----*/
.use_case_contents_box {
  color: #ffffff;
  width: 100%;
  text-align: center;
  line-height: 250px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 80px;
  text-align: justify;
  justify-content: space-between;
  height: 550px!important;
}
.use_case {
  padding-top: 120px;
}
.use_case h2 {
  text-align: center;
  padding-bottom: 30px;
}
.swiper-button-next, .swiper-button-prev {
  top: 50%;
}
.swiper-slide h4 {
  font-size: 24px;
  width: 100%;
  line-height: 1.8;
  letter-spacing: 3px;
}
.use_case_contents_box_img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60%;
}
.use_case_contents_box_text {
  height: 40%;
}

/*---- qa-list ----*/
.qa-list {
  max-width: 960px;
  margin: 160px auto 180px;
}
.qa-list h2 {
  text-align: center;
  padding-bottom: 50px;
}
.qa-list dl {
  position: relative;
  margin: 0;
  padding: 28px 80px 28px 0px;
  cursor: pointer;
  border-bottom: 1px solid #000;
}
.qa-list dl:first-of-type {
  border-top: 1px solid #000;
}
.qa-list dl::before {
  position: absolute;
  top: 35px;
  right: 35px;
  display: block;
  width: 7px;
  height: 7px;
  margin: auto;
  content: '';
  transform: rotate(135deg);
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  box-sizing: content-box;
}
.qa-list .open::before {
  transform: rotate(-45deg);
}
.qa-list dl dt {
  position: relative;
}
.qa-list dl dd {
  position: relative;
  display: none;
  height: auto;
  margin: 20px 0 0;
}
.qa-list dl dd p {
  margin: 30px 0 0;
}
.qa-list dl dd p:first-child {
  margin-top: 0;
}
.qa a {
  text-decoration: underline;
}

/*---- contact ----*/
.contact h2 {
  text-align: center;
  padding-bottom: 50px;
  line-height: 0;
}
.contact_contents {
  background-color: #F7F7F7;
  width: 100%;
  height: 400px;
  position: relative;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.contact_contents_back {
  background-color: #000000;
  clip-path: polygon(0 0, 39% 0, 100% 100%, 0% 100%);
  width: 50%;
  height: 400px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.contact_contents_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  align-items: center;
  max-width: 800px;
  z-index: 1;
}
.contact_contents_box img {
  height: 280px;
}
.contact_contents_box_text {
  width: 51%;
  text-align: center;
}
.contact_contents_box_text .mv_contents_box_btn a {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-feature-settings: "palt";
  line-height: 1;
  letter-spacing: 2px;
  text-align: center;
  width: 45%;
}
.contact_contents_box_text .mv_contents_box_btn {
  margin-top: 50px;
}

/*---- partner ----*/
.partner {
  margin: 160px auto 100px;
}
.partner h2 {
  text-align: center;
  margin-bottom: 30px;
}
.partner_contents img {
  height: 90px;
}
.partner_contents {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 960px;
  margin: auto;
}

@media screen and (max-width: 821px) {
  .sp_only {
    display: block;
  }
  .pc_only {
    display: none;
  }

  /*---- main mv----*/
  .mv {
    background-image:url("../assets/img/top_kv_sp.jpg");
    background-position-y: 35%;
  }
  .mv_contents_box {
    left: 0;
    width: 50%;
    bottom: 5%;
    top: auto;
  }
  .about_contents, .product_contents, .spec {
    max-width: 700px;
    padding: 0;
  }

  /*---- about----*/
  .about {
    padding: 70px 0px 50px;
  }

  /*---- product----*/
  .product h2 {
    margin-bottom: 20px;
  }
  .product_contents_box {
    width: 46%;
    margin-bottom: 50px;
  }
  .product_contents_box img {
    width: 100%;
  }
  .product_contents_back {
    clip-path: polygon(0 20%, 100% 0, 100% 100%, 0% 100%);
    width: 100%;
    height: 92%;
    top: 100px;
    bottom: auto;
  }

  /*---- case----*/
  .swiper-slide {
    padding: 50px 16%;
  }

  /*---- FAQ----*/
  .qa-list,.partner {
    max-width: 700px;
  }

  /*---- contact----*/
  .contact_contents_box {
    margin: 0px 50px;
  }
  .contact_contents_box_text {
    width: auto;
  }
  .contact h2 {
    font-size: 32px;
  }
  .contact_contents_back {
    clip-path: polygon(0 0, 40% 0, 85% 100%, 0% 100%);
  }
}

/*-----ipad mini------*/
@media screen and (max-width: 770px) {
  .mv_contents_box_title h1 {
    margin: 20px auto 20px;
  }
}

/*---- qa-list ----*/
@media screen and (max-width: 767px) {
  .qa-list dl {
    position: relative;
    padding: 15px 40px 15px 10px;
  }
  .qa-list dl::before {
    top: 20px;
    right: 20px;
    width: 7px;
    height: 7px;
  }
  .qa-list dl dd {
    margin: 10px 0 0;
    padding: 0 0 0 30px;
    font-size: 14px;
  }
  .qa-list dl dd p {
    margin: 30px 0 0;
  }
  .qa-list dl dd p:first-child {
    margin-top: 0;
  }
}

/*-----iPhoneX_12pro------*/
@media screen and (max-width: 599px) {
  /*---- header----*/
  .mv_contents_box {
    bottom: 8%;
  }
  .mv_contents_box {
    width: 100%;
  }
  .mv_contents_box a {
    font-size: 14px;
    width: 48%;
  }
  .mv img {
    width: 220px;
  }
  .mv_contents_box_title {
    margin-bottom: 18px;
  }
  .mv_contents_box_btn {
      margin: auto;
  }
  h1 {
    font-size: 20px;
    letter-spacing: 4px;
  }
  .mv_contents_box_btn {
    max-width: 320px;
  }

  /*---- about----*/
  .about_contents, .product_contents, .spec,.qa-list, .partner, .partner_contents {
    max-width: 350px;
  }
  .about_contents img {
    width: 315px;
  }

  /*---- product----*/
  .product h2,.use_case h2,.qa-list h2,.partner h2,.contact h2 {
    font-size: 28px;
    padding-left: 30px;
    box-sizing: border-box;
  }
  .product_contents_box {
    width: 47%;
  }
  .product_contents_box p {
    letter-spacing: 0px;
  }
  .product_contents_back {
    height: 90%;
  }
  .spec {
    flex-wrap: wrap;
  }
  .spec_box {
    width: 30%;
  }
  .spec_box h3 {
    height: 100%;
    line-height: 1.3;
  }

  /*---- case----*/
  .swiper-slide {
    padding: 50px 10%;
  }
  .use_case {
    padding-top: 10px;
  }
  .use_case_contents_box {
    padding: 25px 28px;
  }
  .swiper-slide h4 {
    font-size: 19px;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev,.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    width: 10%!important;
  }
  .use_case_contents_box_img {
    height: 50%;
  }
  .use_case_contents_box_text {
    height: 45%;
  }
  .contact_contents_box {
    margin: auto;
    flex-direction: column-reverse;
  }
  .contact_contents_back {
    clip-path: polygon(0 70%, 100% 50%, 100% 100%, 0 100%);
      width: 100%;
  }
  .contact_contents {
    height: 750px;
  }
  .contact_contents_box_text .mv_contents_box_btn {
    margin-top: 30px;
    margin-bottom: 50px;
  }
  .contact_contents_box_text .mv_contents_box_btn a {
    width: 48%;
  }
  .partner_contents img {
    height: 50px;
  }
  .qa-list,.partner {
    margin: 90px auto 100px;
  }
  .qa-list dl dd {
    padding: 0;
  }
}

/*-----iPhoneSE------*/
@media screen and (max-width: 376px) {
  .use_case h2 {
    font-size: 27px;
  }
  .swiper-slide h4 {
    font-size: 18px;
  }
  .use_case_contents_box_img {
      height: 40%;
    }
  .use_case_contents_box_text {
    height: 53%;
  }
}

/* fadeUp */
.fadeUp {
  animation-name: fadeUpAnime;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
}

@keyframes fadeUpAnime {
  from {
    opacity: 0;
    transform: translateY(100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* スクロールをしたら出現する要素にはじめに透過0を指定 */

.fadeUpTrigger {
  opacity: 0;
}

/* スクロールをしたら出現する要素にはじめに透過0を指定 */

.fadeInTrigger {
  opacity: 0;
}

</style>
